<template>
  <div id="recruit">
    <div class="mainWidth">
      <div class="main_box">
        <!-- 页面标题 -->
        <div class="page_title">
          <h1>加入我们</h1>
          <p class="subtitle">Join Us - 诚邀英才，共创未来</p>
        </div>

        <!-- 职位列表 -->
        <div class="position_list">
          <div class="position_card" v-for="position in positions" :key="position.id">
            <div class="position_header">
              <h2 class="position_title">{{ position.title }}</h2>
              <div class="position_salary">{{ position.salary }}</div>
            </div>

            <div class="position_content">
              <div class="section">
                <h3>岗位职责</h3>
                <ul>
                  <li v-for="(item, index) in position.responsibilities" :key="'resp-'+index">
                    {{ item }}
                  </li>
                </ul>
              </div>

              <div class="section">
                <h3>任职要求</h3>
                <ul>
                  <li v-for="(item, index) in position.requirements" :key="'req-'+index">
                    {{ item }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- HR 联系区域 -->
        <div class="hr_contact">
          <div class="hr_title">联系我们</div>
          <div class="hr_info">
            <span class="hr_item">
              <i class="icon"></i>
              联系人：{{ hr.name }}
            </span>
            <span class="hr_item">
              <i class="icon"></i>
              邮箱：{{ hr.email }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import recruitData from '@/assets/data/recruit.json'

export default {
  name: 'recruit',
  data() {
    return {
      positions: recruitData.positions,
      hr: recruitData.hr
    }
  },
  created() {

  },
  methods: {
    changeTab(idx) {
      this.activeTab = idx
    }
  }
}
</script>

<style scoped lang="less">
#recruit {
  overflow: hidden;
  background-color: #E6E6E6;
  padding-bottom: 60px;

  .main_box {
    background: #fff;
    overflow: hidden;
    margin-top: 17px;
    padding: 88px;

    .page_title {
      text-align: center;
      margin-bottom: 60px;

      h1 {
        font-size: 46px;
        color: #3B3B3B;
        font-weight: 600;
        margin-bottom: 10px;
      }

      .subtitle {
        font-size: 18px;
        color: #9196AC;
        letter-spacing: 2px;
      }
    }

    .position_list {
      .position_card {
        background: #F9F9F9;
        border-radius: 8px;
        padding: 30px;
        margin-bottom: 30px;
        border-left: 4px solid #2095D4;

        .position_header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 25px;
          padding-bottom: 20px;
          border-bottom: 2px solid #E6E6E6;

          .position_title {
            font-size: 24px;
            color: #3B3B3B;
            font-weight: 600;
            margin: 0;
          }

          .position_salary {
            font-size: 18px;
            color: #2095D4;
            font-weight: 600;
            background: rgba(32, 149, 212, 0.1);
            padding: 8px 20px;
            border-radius: 20px;
          }
        }

        .position_content {
          .section {
            margin-bottom: 20px;

            &:last-child {
              margin-bottom: 0;
            }

            h3 {
              font-size: 16px;
              color: #3B3B3B;
              font-weight: 600;
              margin-bottom: 15px;
            }

            ul {
              list-style: none;
              padding: 0;
              margin: 0;

              li {
                font-size: 14px;
                color: #666;
                line-height: 24px;
                padding-left: 20px;
                position: relative;

                &:before {
                  content: '•';
                  position: absolute;
                  left: 0;
                  color: #2095D4;
                  font-size: 18px;
                }
              }
            }
          }
        }
      }
    }

    .hr_contact {
      background: #F9F9F9;
      padding: 40px;
      border-radius: 8px;
      text-align: center;
      margin-top: 40px;

      .hr_title {
        font-size: 20px;
        color: #3B3B3B;
        font-weight: 600;
        margin-bottom: 20px;
      }

      .hr_info {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 40px;

        .hr_item {
          font-size: 16px;
          color: #666;
          display: flex;
          align-items: center;
          gap: 10px;

          .icon {
            width: 20px;
            height: 20px;
            background: #2095D4;
            border-radius: 50%;
          }
        }
      }
    }
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  #recruit .main_box {
    padding: 30px 20px;

    .page_title h1 {
      font-size: 32px;
    }

    .position_list .position_card {
      padding: 20px;

      .position_header {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;

        .position_salary {
          align-self: flex-start;
        }
      }
    }

    .hr_contact {
      padding: 30px 20px;

      .hr_info {
        flex-direction: column;
        gap: 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/childrens/recruit.vue